import { useMemo } from 'react';
import { useGlobalState } from '../presentation/global/context/global-context';
import { IMenuResponse } from '../model/base/response/menu-response';

const byOrder = (a: { orderNumber?: number }, b: { orderNumber?: number }) => (a.orderNumber || 0) - (b.orderNumber || 0);

const withPublishedItems = (menu: IMenuResponse): IMenuResponse => ({
    ...menu,
    items: menu.items?.filter(item => item.isPublished === true).sort(byOrder) || []
});

/**
 * menus: menus do "Mais opções" (sem chave): os de link direto e os que têm itens publicados.
 * mainMenus: menus fixos da barra principal (com chave), na ordem definida pela entidade;
 * vazio quando a entidade ainda não materializou os fixos (o menu usa a estrutura padrão).
 */
export const useMenusData = () => {
    const { menus } = useGlobalState();

    const filteredMenus = useMemo(() => {
        if (!menus) return [];

        return menus
            .filter((menu: IMenuResponse) => !menu.key)
            .map(withPublishedItems)
            .filter((menu: IMenuResponse) => !!menu.url || (menu.items && menu.items.length > 0))
            .sort(byOrder);
    }, [menus]);

    const mainMenus = useMemo(() => {
        if (!menus) return [];

        return menus
            .filter((menu: IMenuResponse) => !!menu.key)
            .map(withPublishedItems)
            .sort(byOrder);
    }, [menus]);

    return { menus: filteredMenus, mainMenus, loading: !menus };
};
